module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_9006.f190c43a.png";